import serviceCategories from '@/constants/serviceCategories'

export default {
  computed: {
    serviceCategoriesList () {
      const {serviceName = 'BB'} = this.currentCompany
      const service = serviceCategories.find((el) => el.id === 2)
      service.name = `${serviceName} Service`
      return serviceCategories
    },
    currentCompany () {
      return this.$store.getters.currentCompany
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/serviceCategoriesList.js